const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLoginForm({ email, senha }) {
  if (!email.trim() || !senha) return "Preencha e-mail e senha.";
  if (!EMAIL_PATTERN.test(email.trim())) return "Digite um e-mail válido.";
  return null;
}

function waitMessage(retryAfterSeconds) {
  const minutes = Math.ceil(Number(retryAfterSeconds) / 60);
  return Number.isFinite(minutes) && minutes > 0
    ? `Aguarde cerca de ${minutes} minuto(s) e tente novamente.`
    : "Aguarde alguns minutos e tente novamente.";
}

// Mensagens fixas: o texto do servidor nunca chega à tela, para não expor
// detalhes internos nem dizer se um e-mail tem conta.
export function loginErrorMessage(error) {
  const response = error?.response;
  if (!response) {
    return error?.code === "ECONNABORTED"
      ? "O servidor demorou para responder. Tente novamente."
      : "Não foi possível conectar. Verifique sua internet e tente novamente.";
  }

  switch (response.status) {
    case 400:
      return "Verifique o e-mail e a senha digitados.";
    case 401:
      return "E-mail ou senha incorretos.";
    case 429:
      return `Muitas tentativas de acesso. ${waitMessage(response.headers?.["retry-after"])}`;
    default:
      return "Não foi possível entrar agora. Tente novamente em instantes.";
  }
}
